<template>
  <div>
    <!-- <add-reminder-workflow /> -->
    <!-- <edit-reminder-workflow /> -->
    <!-- <reminder-workflow-list /> -->
    <router-view />
  </div>
</template>

<script>
export default {
  components: {
    AddReminderWorkflow: () =>
      import("@/views/CompanyUser/ReminderWorkflow/AddReminderWorkflow.vue"),
    EditReminderWorkflow: () =>
      import("@/views/CompanyUser/ReminderWorkflow/EditReminderWorkflow.vue"),
    ReminderWorkflowList: () =>
      import("@/views/CompanyUser/ReminderWorkflow/ReminderWorkflowList.vue")
  }
};
</script>

<style lang="scss" scoped>
</style>
